import type { AppPermissionModule } from '@/core/auth/permissions/types';

import { engagementLetterDatabaseRolePermissions } from './permissions';
import type { EngagementLetterDatabasePermissions, EngagementLetterDatabaseRole } from './permissions';

export { ENGAGEMENT_LETTER_DATABASE_ROLES } from './permissions';
export type {
  EngagementLetterDatabasePermissions,
  EngagementLetterDatabaseRole,
  EngagementRecordResource,
  WaiverRecordResource,
} from './permissions';

/** Permission module registered with the portal for this app. */
export const engagementLetterDatabasePermissions: AppPermissionModule<
  EngagementLetterDatabaseRole,
  EngagementLetterDatabasePermissions
> = {
  appId: 'engagement-letter-database',
  roles: engagementLetterDatabaseRolePermissions,
};
